import React from 'react';

const ThreeColumnWithDetailContent =
  ({
    DetailContentFn,
    ThreeColumnContentFn,
    mapVariantToProps,
    mapVariantToClassName,
    isAutoLayout,
    ...props
  }: any) =>
  ({ title, leftColumn = [], centerColumn = [], rightColumn = [], theme, className }: any) => (
    <ThreeColumnContentFn
      title={title}
      className={className}
      theme={theme}
      isAutoLayout={isAutoLayout}
      leftColumn={
        leftColumn && (
          <DetailContentFn
            content={leftColumn}
            mapVariantToProps={mapVariantToProps}
            mapVariantToClassName={mapVariantToClassName}
            theme={theme}
          />
        )
      }
      centerColumn={
        centerColumn && (
          <DetailContentFn
            content={centerColumn}
            mapVariantToProps={mapVariantToProps}
            mapVariantToClassName={mapVariantToClassName}
            theme={theme}
          />
        )
      }
      rightColumn={
        rightColumn && (
          <DetailContentFn
            content={rightColumn}
            mapVariantToProps={mapVariantToProps}
            mapVariantToClassName={mapVariantToClassName}
            theme={theme}
          />
        )
      }
    />
  );

export default ThreeColumnWithDetailContent;
